import React from 'react';
import { Notification } from '@codeparva/ui-components-library';

export const UserFlowError = (hasError: any, error: any) => {
  const userFriendlyStatusRegex = new RegExp('^4[0-9][0-9]|5[0-9][0-9]$');

  const { status = '', errorMessage = '' } = error || {};

  const errorMessageToShow = userFriendlyStatusRegex.test(status.toString())
    ? errorMessage
    : 'Something went wrong. Please try again later.';

  if (hasError && error) {
    return (
      <div className="notificationSection">
        <Notification color="danger" light={true}>
          {errorMessageToShow}
        </Notification>
      </div>
    );
  }

  return <></>;
};
